import type { Order } from '../../../proto/generated/order'

export type OrderFiredAlert = Order & { orderAlertId: string }

/** Order toast content is fixed at fire time — skip re-render when parent re-renders with the same alert ref. */
export const orderFiredAlertPropsEqual = (
    prev: { order: OrderFiredAlert },
    next: { order: OrderFiredAlert }
): boolean => prev.order === next.order
